import { Injectable, OnDestroy, effect, signal } from '@angular/core';
import { from } from 'rxjs';

import { API_SUPPRESS_PROGRESS_HEADER, ApiService } from 'src/app/infrastructure/services/api-service/api.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

// Badge-teller: ongelezen berichten in de open chats van de gebruiker, over alle domains (GET /api/Chat/unread-count).
// Polling i.p.v. push: elke 60 s, alleen ingelogd en alleen als het tabblad zichtbaar is; bij terugkeer naar het
// tabblad en bij inloggen meteen. refresh() na een eigen actie (bericht gelezen, afgerond) werkt de badge direct bij.
@Injectable({
    providedIn: 'root'
})
export class ChatPollingService
    implements OnDestroy
{
    static readonly intervalMs = 60000;

    private readonly __apiService = injectRequired(ApiService);
    private readonly __authService = injectRequired(AuthService);

    private readonly __unreadCount$$ = signal<number>(0);
    readonly unreadCount$$ = this.__unreadCount$$.asReadonly();

    private readonly __timerId = setInterval(() => this.__poll(), ChatPollingService.intervalMs);
    private readonly __onVisible = () => this.__poll();

    // Inloggen: meteen ophalen; uitloggen: badge leeg.
    private readonly __login_sync = effect(() => {
        if (this.__authService.token$$()) this.refresh();
        else this.__unreadCount$$.set(0);
    });

    constructor() {
        document.addEventListener('visibilitychange', this.__onVisible);
    }

    refresh(): void {
        if (!this.__authService.token$$()) return;

        from(this.__apiService.GET('/api/Chat/unread-count', {
            headers: { [API_SUPPRESS_PROGRESS_HEADER]: 'true' },
        })).subscribe({
            next: r => {
                if (r.error) return;
                // Eén badge voor chat en bericht (Message, fase 2b): beide tellers samen.
                this.__unreadCount$$.set(((r.data as any)?.count ?? 0) + ((r.data as any)?.messageCount ?? 0));
            },
            error: () => { /* achtergrond-poll: geen melding */ },
        });
    }

    private __poll(): void {
        if (!document.hidden) this.refresh();
    }

    ngOnDestroy(): void {
        clearInterval(this.__timerId);
        document.removeEventListener('visibilitychange', this.__onVisible);
    }
}
